import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:8080";
  const hostname = window.location.hostname;
  if (hostname && hostname !== "localhost" && hostname !== "127.0.0.1" && hostname !== "") {
    return envUrl
      .replace("localhost", hostname)
      .replace("127.0.0.1", hostname);
  }
  return envUrl;
}
